function addPackToCart(variantId, event) {
    event.preventDefault();
    if (!variantId) return;
    
    let btn = event.currentTarget;
    btn.style.opacity = '0.5';
    
    const isAdded = btn.classList.contains('clicked-state');

    if (isAdded) {
      let formData = {
        'id': variantId,
        'quantity': 0
      };

      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        btn.style.opacity = '1';
        btn.classList.remove('clicked-state');
        if (typeof updateHeaderCartCount === 'function') {
          updateHeaderCartCount();
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(error => {
        console.error('Error:', error);
        btn.style.opacity = '1';
      });
    } else {
      let formData = {
        'items': [{
          'id': parseInt(variantId),
          'quantity': 1
        }]
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        btn.style.opacity = '1';
        btn.classList.add('clicked-state');
        if (typeof updateHeaderCartCount === 'function') {
          updateHeaderCartCount();
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:add', { bubbles: true }));
      })
      .catch(error => {
        console.error('Error:', error);
        btn.style.opacity = '1';
      });
    }
  }
